import Vue from 'vue'
import { getHomePageTitle } from '@/auth/utils'

export default [
  {
    title: getHomePageTitle(),
    route: 'home',
    icon: 'HomeIcon',
    resource: 'Home',
    action: 'read',
  },
  {
    title: 'Users',
    route: 'users',
    icon: 'UsersIcon',
    resource: 'All',
    action: 'read',
  },
  {
    title: 'Category Subject',
    route: 'category-subject',
    icon: 'GitMergeIcon',
    resource: 'CategorySubject',
    action: 'read',
  },
  {
    title: 'Science sector directions',
    route: 'direction-sector-codes',
    icon: 'Share2Icon',
    resource: 'DirectionSectorCode',
    action: 'read',
  },
  {
    title: 'Direction',
    route: 'direction',
    icon: 'ListIcon',
    resource: 'All',
    action: 'read',
  },
  {
    title: 'Period',
    route: 'period',
    icon: 'CalendarIcon',
    resource: 'All',
    action: 'read',
  },
  {
    title: 'My Students',
    route: 'advisor-students',
    icon: 'UsersIcon',
    resource: 'AdvisorStudent',
    action: 'read',
  },
  {
    title: 'Zone',
    icon: 'MapPinIcon',
    tagVariant: 'light-warning',
    resource: 'All',
    action: 'read',
    children: [
      {
        title: 'Country',
        route: 'country',
        resource: 'All',
        action: 'read',
      },
      {
        title: 'Region',
        route: 'region',
        resource: 'All',
        action: 'read',
      },
      {
        title: 'District',
        route: 'district',
        resource: 'All',
        action: 'read',
      },
    ],
  },
  {
    title: 'Organizations',
    route: 'organizations',
    icon: 'LayersIcon',
    resource: 'All',
    action: 'read',
  },
  {
    title: 'Letter',
    icon: 'MessageSquareIcon',
    tagVariant: 'light-warning',
    children: [
      {
        title: 'Sent',
        route: 'letter',
        resource: 'Letter',
        action: 'read',
      },
      {
        title: 'Inbox',
        route: 'inbox',
        resource: 'Letter',
        action: 'read',
      },
      {
        title: 'Maqsadli xatlar',
        route: 'targeted-letters',
        resource: 'TargetedLetter',
        action: 'read',
      },
      {
        title: 'So‘rovlar',
        route: 'request-letters',
        resource: 'Letter',
        action: 'read',
      },
      {
        title: 'Quote Agreement',
        route: 'quoteAgreement',
        resource: 'QuoteAgreement',
        action: 'read',
      },
    ],
  },
  {
    title: 'Applicant Documents',
    route: 'applicant-document',
    resource: 'ApplicantDocument',
    action: 'read',
  },
  {
    title: 'Imtihon dasturlari va taqdimotlar',
    route: 'exam-program-presentations',
    icon: 'FileTextIcon',
    resource: 'ExamProgramPresentation',
    action: 'read',
  },
  {
    title: 'UzAsbo',
    icon: 'DollarSignIcon',
    tagVariant: 'light-warning',
    resource: 'UzAsbo',
    action: 'read',
    children: [
      {
        title: 'Monthly lists',
        route: 'uz-asbo',
        resource: 'UzAsbo',
        action: 'read',
      },
      {
        title: 'Monthly summary',
        route: 'uz-asbo-monthly',
        resource: 'UzAsboMonthly',
        action: 'read',
      },
    ],
  },
  {
    title: 'Personal documents',
    icon: 'LayersIcon',
    tagVariant: 'light-warning',
    children: [
      {
        title: 'Apply Documents',
        route: 'apply-document',
        icon: 'BriefcaseIcon',
        resource: 'ApplyDocument',
        action: 'read',
      },
      {
        title: 'Work plan',
        route: 'monitoring',
        resource: 'Monitoring',
        action: 'read',
      },
      {
        title: 'Monitoring Report',
        route: 'monitoring-report',
        resource: 'MonitoringReportDoctorate',
        action: 'read',
      },
    ],
  },
  {
    title: 'Apply Documents All',
    route: 'apply-document-all',
    icon: 'BriefcaseIcon',
    resource: 'ApplyDocumentAll',
    action: 'read',
  },
  {
    title: 'Research Advisor',
    route: 'research-advisor',
    icon: 'UserIcon',
    resource: 'ResearchAdvisor',
    action: 'read',
  },
  {
    title: 'Searchers List',
    icon: 'UsersIcon',
    resource: 'StudentList',
    action: 'read',
    children: [
      {
        title: 'Doctoral And Trainee Researchers',
        route: 'student-list-dt',
      },
      {
        title: 'Independent students',
        route: 'student-list-i',
      },
      {
        title: 'Scholarship Foreign',
        route: 'student-list-f',
      },
      {
        title: 'Scholarship Organization',
        route: 'student-list-o',
      },
    ],
  },
  {
    title: 'Notification',
    route: 'notification',
    icon: 'BellIcon',
    resource: 'Notification',
    action: 'read',
  },
  {
    title: 'Quote distribution',
    route: 'quote-distribution',
    icon: 'AlertTriangleIcon',
    resource: 'Distribution',
    action: 'read',
  },
  {
    title: 'Posts',
    route: 'post',
    icon: 'BookOpenIcon',
    resource: 'All',
    action: 'read',
  },
  {
    title: 'Exams',
    route: 'exam',
    icon: 'AwardIcon',
    resource: 'Exam',
    action: 'read',
  },
  {
    title: 'Exams',
    route: 'all-exams',
    icon: 'AwardIcon',
    resource: 'ExamResultInnovation',
    action: 'read',
  },
  {
    title: 'Scientific topics',
    icon: 'LayersIcon',
    resource: 'ScientificTopicProtocol',
    action: 'manage',
    children: [
      {
        title: 'Topics',
        route: 'confirmed-scientific-topic',
        resource: 'ScientificTopicProtocol',
        action: 'manage',
      },
      {
        title: 'Scientific topic protocols',
        route: 'confirmed-scientific-topic-protocol',
        resource: 'ScientificTopicProtocol',
        action: 'manage',
      },
    ],
  },
  {
    title: 'Additional exam',
    route: 'additional-exam',
    icon: 'FolderPlusIcon',
    resource: 'AdditionalExam',
    action: 'read',
  },
  {
    title: 'Monitoring',
    icon: 'HexagonIcon',
    children: [
      {
        title: 'Check Monitoring',
        route: 'org-monitoring',
        resource: 'OrgMonitoring',
        action: 'read',
      },
      {
        title: 'Monitoring Report',
        route: 'monitoring-report-otm',
        resource: 'MonitoringReportOtmItm',
        action: 'read',
      },
      {
        title: 'Monitoring Report',
        route: 'monitoring-report-inno',
        resource: 'MonitoringReportInnovation',
        action: 'read',
      },
      {
        title: 'Check Monitoring',
        route: 'check-monitoring-inno',
        resource: 'MonitoringReportInnovation',
        action: 'read',
      },
      {
        title: 'Monitoring Report Advisor',
        route: 'monitoring-report-advisor',
        resource: 'MonitoringReportAdvisor',
        action: 'read',
      },
    ],
  },
  {
    title: 'Attestation work',
    route: 'attestation-work',
    icon: 'HexagonIcon',
    // resource: 'All',
    // action: 'read',
  },
  {
    title: 'Settings',
    icon: 'SettingsIcon',
    children: [
      {
        title: 'Settings',
        route: 'settings',
        resource: 'Settings',
      },
      {
        title: 'Certificate',
        route: 'certificate',
        resource: 'Certificate',
      },
    ],
  },
  {
    title: 'Did you find an error?',
    href: Vue.prototype.$technicalAdminLink,
    icon: 'SendIcon',
  },
]
